import axios from 'axios';
import Swal from "sweetalert2";
import config from 'src/config'; // Import the config file
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import errorIcon from "src/assets/images/error.svg";
class PythonService {


  constructor() {

    var USER_TOKEN = localStorage.getItem('access_key');
    const AuthStr = 'Bearer '.concat(USER_TOKEN);
    // console.log(AuthStr);
    let pythonService = axios.create({
      // headers: {
      //   'Authorization': AuthStr
      // },

    });
    pythonService.interceptors.response.use(this.handleSuccess, this.handleError);
    this.pythonService = pythonService;
  }
  appUrl() {
    var entity = localStorage.getItem('entity');
    var url = config[process.env.REACT_APP_ENVIRONMENT].apiUrl;
    return url;
  }
  makeURL(words) {
    var n = words.split("/");
    var module = n[n.length - 3];
    var tabname = n[n.length - 2];
    return "" + module + "/" + tabname;
  }
  makeFilterURL(words) {
    var n = words.split("/");
    var module = n[n.length - 2];
    var tabname = n[n.length - 1];
    return "" + module + "/" + tabname;
  }
  dateTimeString() {
    var today = new Date();
    var date = today.getFullYear() + '' + (today.getMonth() + 1) + '' + today.getDate();
    var time = today.getHours() + "" + today.getMinutes() + "" + today.getSeconds();
    var CurrentDateTime = date + '_' + time;
    return CurrentDateTime;
  }
  baseUrl() {
    var url =config[process.env.REACT_APP_ENVIRONMENT].pythonUrl;
    return url;
  }
  ServicesUrl() {
    var entity = localStorage.getItem('entity');
    var value = 0;
    if (entity == '12345') {
      value = 1;
    } else {
      value = entity
    }
    var url = config[process.env.REACT_APP_ENVIRONMENT].pythonUrl;
    return url;
  }

  handleSuccess(response) {
    return response;
  }

  handleError = (error) => {
   
    switch (error.response.status) {
      case 401:    
      Swal.fire({
        imageUrl: "https://saddlepointtech.com/error.png",       
        text: error.response.data['message'],         
      });
        break;
      case 404:
        Swal.fire({
          imageUrl: "https://saddlepointtech.com/error.png",
          imageHeight: 200,
          text: "Oops...Page not found",
          focusConfirm: false,
          showCloseButton: true,    
        });
        break;
      case 403:
        Swal.fire({
          imageUrl: "https://saddlepointtech.com/error.png",
          text: error.response.data['message'],      
          focusConfirm: false,
          showCloseButton: true,     
          imageHeight: 200, 
        });
        break;
      case 400:
        Swal.fire({
          imageUrl: "https://saddlepointtech.com/error.png",
          focusConfirm: false,
          showCloseButton: true,     
          imageHeight: 200, 
          text: error.response.data['message'],         
        });
        return error.response.data['message'];
        break;

      case 500:
        Swal.fire({
          imageUrl: "https://saddlepointtech.com/error.png",
          focusConfirm: false,
          showCloseButton: true,     
          imageHeight: 200, 
          text: "Oops...Something went wrong!",
        });
        return  "Oops...Something went wrong!";
        break;
      default:
        // this.redirectTo(document, '/500')
        break;
    }
    return Promise.reject(error)
  }

  redirectTo = (document, path) => {
    document.location = path
  }

  get(path) {
    return this.pythonService.get(this.baseUrl() + '' + path)
      .then(response => response.data)
      .catch(error => {
        console.error("Error fetching data for the child dropdown:", error);
        throw error; // Rethrow the error to be handled in the calling function
      });
  }


  get(path, callback) {

    return this.pythonService.get(this.baseUrl() + '' + path).then(
      (response) => callback(response.status, response.data)
    );
  }

  apiGet(path, callback) {
    var response = this.pythonService.get(this.baseUrl() + '' + path);
    return response;
  }

  put(path, payload, callback) {
    return this.pythonService.request({
      method: 'PUT',
      url: this.baseUrl() + '' + path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(response.status, response.data));
  }

  post(path, payload, callback) {

    return this.pythonService.request({
      method: 'POST',
      url: this.baseUrl() + '' + path,
      responseType: 'json',
      data: payload,

    }).then((response) => callback(response.status, response.data));
  }

  delete(path, payload, callback) {

    return this.pythonService.request({
      method: 'DELETE',
      url: this.baseUrl() + '' + path,
      responseType: 'json',
      data: payload,

    }).then((response) => callback(response.status, response.data));
  }


  groupByKey(array, key) {
    return array
      .reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
      }, {})
  }
  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  switchColors() {
    var r, g, b, rg, gb, rb;
    var range = 255; // controls the range of r,g,b you would like
    var sep = range / 4; // controls the minimum separation for saturation
    do {
      r = Math.floor(Math.random() * range);
      g = Math.floor(Math.random() * range);
      b = Math.floor(Math.random() * range);

      rg = Math.abs(r - g);
      gb = Math.abs(g - b);
      rb = Math.abs(r - b);
    } while (rg < sep || gb < sep || rb < sep);

    //convert the rgb to hex

    function rgbtohex(rgb) {
      var first, second; // makes the two hex code for each rgb value

      first = Math.floor(rgb / 16); //get first unit of hex
      second = rgb % 16; //get second unit of hex
      // convert to string with hex base 16
      first = first.toString(16);
      second = second.toString(16);
      //concatenate the two units of the hex
      var rgbtohex = first + second;
      //return the two unit hex code for the r,g,b value
      return rgbtohex;
    }

    //convert the r,g,b numbers to hex code by calling the rgbto hex function
    var r_str = rgbtohex(r),
      g_str = rgbtohex(g),
      b_str = rgbtohex(b);
    //concatenate the final string for the output
    var final = '#' + r_str + g_str + b_str;

    //output random color
    return final;
  }
  extractNumbers(string) {
    const numbers = string.match(/\d+/g);
    return numbers ? numbers.map(Number) : [];
  }

  groupObjectsByPermissionName(data) {
    const groupedData = {};

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const subArray = data[key];
        groupedData[key] = {};

        subArray.forEach(obj => {
          const permissionName = obj.permissionName;
          if (groupedData[key][permissionName]) {
            groupedData[key][permissionName].push(obj);
          } else {
            groupedData[key][permissionName] = [obj];
          }
        });
      }
    }

    return groupedData;
  }

  mergeObjectsWithSameKey(data) {
    const mergedData = {};

    data.forEach(obj => {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (Array.isArray(mergedData[key])) {
            mergedData[key] = mergedData[key].concat(obj[key]);
          } else {
            mergedData[key] = obj[key];
          }
        }
      }
    });

    return mergedData;
  }

  async permission(Auth, tabName) {

    let PermittedScreens = ["tabreportConfig", "permission_grant", "user_config"]

    if (PermittedScreens.includes(tabName)) {
      // localStorage.removeItem('permissions');
      var url = this.baseUrl() + "process/permission";
      const Permission = await axios.get(url, Auth);
      console.log(Permission)
      const mergedPermissions = this.mergeObjectsWithSameKey(Permission.data);
      const AllPermissions = this.groupObjectsByPermissionName(mergedPermissions);
      console.log(AllPermissions);
      localStorage.setItem('permissions', JSON.stringify(AllPermissions));

      var Emptyprocesses = []
      Object.entries(AllPermissions).forEach(([k, v]) => {
        if (Object.keys(v).length !== 0) {
          Emptyprocesses.push(k)
        }
      })
      console.log(Emptyprocesses)

      var url = this.baseUrl() + "admin_configuration/process";
      const process = await axios.get(url, Auth);
      const data = process.data
      var processes = []
      for (let process of data) {
        if (Emptyprocesses.includes(process.processName)) {
          processes.push(process)
        }
      }
      localStorage.setItem('process', JSON.stringify(processes));

      window.location.reload()
    }

  }
  formatYAxisLabel(val){
    if(val !== undefined){
    const absVal = Math.abs(val);
    if (absVal >= 1e12) {
      return (val / 1e12).toFixed(2) + 'T';
    } else if (absVal >= 1e9) {
      return (val / 1e9).toFixed(2) + 'B';
    } else if (absVal >= 1e6) {
      return (val / 1e6).toFixed(2) + 'M';
    } else if (absVal >= 1e3) {
      return (val / 1e3).toFixed(2) + 'K';
    }
    return val.toFixed(2);
   }else{
    return val;
   }
  };
  checkPermission(module, tabname) {
    var permission = JSON.parse(localStorage.getItem("permissions"));

    if (!permission[module]) {
      return false
    }

    if (tabname) {
      const screenKeyLowerCase = tabname + " view";
      const screenKeyUpperCase = tabname + " View";
      console.log(screenKeyLowerCase, screenKeyUpperCase);
      console.log(permission[module][screenKeyLowerCase], !permission[module][screenKeyUpperCase])
      if (permission[module][screenKeyLowerCase] || permission[module][screenKeyUpperCase]) {
        return true
      } else {
        return false
      }
    }
    return true

  }

}

export default new PythonService;
